import { takeEvery, call, put, all, select } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import {
    LOAD_VIDEOLISTS_ALL_BY_ID,
    loading, putVideolistsAll,
    putVideolistsAllSongs,
    toggleSelectedVideoAll,
    toggleVideolistsAllSongs
} from '../../store/ContentAllVideolists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'
import { SELECT_ALL_PLAYLIST_CLIPS_ID } from '../../store/ContentVideolists/actions'

export default function* () {
    yield takeEvery(SELECT_ALL_PLAYLIST_CLIPS_ID, worker)
}

function* worker() {

    yield put(toggleVideolistsAllSongs(true))

    try {

        let selected = yield select(state => state.videolists_all.selected);


        if (!selected[0]) {
            return
        }



        let videolists = yield select(state => state.videolists_all.allVideolists);
        let limit = 50

        videolists.forEach(list => {
            if (list.id === selected[0]) {
                limit = list.totalcount

            }
            return list;
        })
        const p ={
            playlist_id:selected[0],
            column:['id'],
            limit,
            offset:0
        }
        const fetchedVideolist = yield call(fetchClips, p)

        if (fetchedVideolist.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${SELECT_ALL_PLAYLIST_CLIPS_ID}.`, fetchedVideolist],
                text: "Ролики не были загружены. Попробуйте перезагрузить страницу."
            }))
            //yield put(putVideolistsAll({ videolists }))

        } else {

           const ids = fetchedVideolist.success.map(el =>el.id)

            yield put(toggleSelectedVideoAll({
                setAll: true,
                id_video: ids
            }))
        }
    } catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${SELECT_ALL_PLAYLIST_CLIPS_ID}.`, e],
            text: "Плейлисты не были загружены. Попробуйте перезагрузить страницу."
        }))
        yield put(putVideolistsAllSongs([]))
        yield put(putVideolistsAll({ videolists: [] }))
    } finally {
        yield put(loading(false))
        yield put(toggleVideolistsAllSongs(false))

    }
}



function fetchClips(params) {

    return axios.get(`/videolist/tracks/search`, {
        params
    })
        .then(response => response.data)
}